<template>
  <div></div>
</template>
<script>
export default {
  created() {
    localStorage.removeItem('ms_username');
    localStorage.removeItem('ms_token');
    localStorage.removeItem('ms_nickname');
    localStorage.removeItem('ms_role');
    localStorage.removeItem('ms_id');
    let back_url = this.getQueryString('back_url');
    if(back_url){
      this.$router.push({path:'/login', query:{back_url:back_url}})
    }else{
      this.$router.push({path:'/login'})
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
};
</script>
